import state from './store/state';
import mutations from './store/mutations';
import actions from './store/actions';

const store = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default store;
